import * as React from "react";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useState } from "react";
import isoEventLogoClose from "./../../../assets/images/Logo/Logo-Pazirex-Icon.svg";
import isoEventLogoOpen from "./../../../assets/images/Logo/Logo-Pazirex-White.svg";
import { Link, useNavigate } from "react-router-dom";
import isoEventLogo from "./../../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import { ReactComponent as LoginIcon } from "./../../../assets/images/icons/Google SVGs/login.svg";
import { ReactComponent as HomeIcon } from "./../../../assets/images/icons/Google SVGs/home(light).svg";
import { ReactComponent as HomeHealthIcon } from "./../../../assets/images/icons/Google SVGs/home_health.svg";
import { ReactComponent as StethoscopeIcon } from "./../../../assets/images/icons/Google SVGs/stethoscope.svg";
import InfoIcon from "./../../../assets/images/icons/Google SVGs/info.svg";
import GavelIcon from "./../../../assets/images/icons/Google SVGs/gavel.svg";

import "./sidebar.scss";

const isMobile = window.innerWidth >= 992 ? false : true;

const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "IRANSans", // Change this to your desired font family
  },
});
const drawerWidth = window.innerWidth >= 992 ? 208 : 0;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  // ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,

  paddingRight: `calc(${theme.spacing(8)} + 1px)`,

  transition: theme.transitions.create(["width", "padding"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    paddingRight: drawerWidth,
    transition: theme.transitions.create(["width", "padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
  // Adjusted for RTL
  "& .MuiPaper-root": {
    right: 0,
    left: "auto",
  },
}));

// const StyledFab = styled(Fab)({
//     position: "absolute",
//     zIndex: 1051,
//     top: 10,
//     left: "auto",
//     right: drawerWidth - 28,
//     margin: "0 auto",
//   });

const MiniDrawer = ({ children }) => {
  const [open, setOpen] = useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <Box dir="rtl" sx={{ display: "flex", position: "relative" }}>
        {/* <StyledFab>
          <IconButton
            // color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              // marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
        </StyledFab> */}
        <CssBaseline />
        <AppBar
          position="fixed"
          open={open}
          sx={{ zIndex: "1050", boxShadow: "0px 0px 20px 0px #0000000D" }}
        >
          <Toolbar
            className="bg-iso-white border-bottom border-bootstrap-gray-300 py-3"
            style={{ height: isMobile ? "68px" : "74px" }}
          >
            {/* where you should create profile dropdown */}
            <IconButton
              // color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                // marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <img
              src={isoEventLogo}
              className="logo-img d-lg-none d-flex"
              alt="..."
            />
            <div
              className="btn background-bootstrap-gray-200 color-bootstrap-gray-800 rounded-3 ms-auto"
              onClick={() => {
                localStorage.setItem(
                  "callBackURL",
                  window.location.pathname + window.location.search
                );
                window.location.replace("/login");
              }}
            >
              ورود | ثبت‌نام
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          open={open}
          sx={{
            "& .MuiPaper-root": {
              background: "linear-gradient(180deg, #343A40 0%, #495159 100%)",
              zIndex: "1050",
            },
          }}
        >
          <DrawerHeader
            className="px-3 justify-content-center position-relative border-bootstrap-gray-600"
            style={{
              height: isMobile ? "68px" : "74px",
              borderBottom: "solid 1px",
            }}
          >
            {open ? (
              <div className="d-flex w-fit mx-auto">
                <img src={isoEventLogoClose} className="w-fit me-2" />
                <img src={isoEventLogoOpen} className="w-fit" />
              </div>
            ) : (
              <img src={isoEventLogoClose} className="w-fit" />
            )}
            <IconButton
              className="position-absolute background-bootstrap-gray-800 color-bootstrap-gray-400 rounded-pill"
              style={{ left: "0px" }} // style={{left:'-20px', bottom: '-20px'}}
              onClick={handleDrawerClose}
              sx={{ ...(!open && { display: "none" }) }}
            >
              <ChevronRightIcon />
            </IconButton>
          </DrawerHeader>
          <List className="color-bootstrap-gray-400">
            {/* list of links */}

            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: open ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : "auto",
                    ml: open ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <LoginIcon width={24} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      className="nav-link"
                      // className="nav-link active"
                      aria-current="page"
                      to="/login"
                      onClick={() => {
                        localStorage.setItem(
                          "callBackURL",
                          window.location.pathname + window.location.search
                        );
                      }}
                    >
                      ورود / ثبت نام
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: open ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : "auto",
                    ml: open ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <HomeIcon width={24} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      className="nav-link"
                      // className="nav-link active"
                      aria-current="page"
                      to="/"
                    >
                      صفحه اصلی
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: open ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : "auto",
                    ml: open ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <HomeHealthIcon width={24} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      className="nav-link"
                      // className="nav-link active"
                      aria-current="page"
                      to="/place-store"
                    >
                      مراکز درمانی
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: open ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : "auto",
                    ml: open ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <StethoscopeIcon width={24} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      className="nav-link"
                      // className="nav-link active"
                      aria-current="page"
                      to="/doctor-store"
                    >
                      پزشکان
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>

            {/* end of list */}
          </List>
          {/* <Divider className="background-bootstrap-gray-400" /> */}
          {/* <List className="color-bootstrap-gray-400"> */}
          {/* list of links */}
          {/* <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: open ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : "auto",
                    ml: open ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img src={InfoIcon} alt="" />
                </ListItemIcon>
                <ListItemText
                  primary={"درباره پذیرکس"}
                  sx={{ textAlign: "right", opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem> */}
          {/* <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: open ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : "auto",
                    ml: open ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img src={GavelIcon} alt="" />
                </ListItemIcon>
                <ListItemText
                  primary={"قوانین و ضوابط"}
                  sx={{ textAlign: "right", opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem> */}
          {/* end of list */}
          {/* </List> */}
        </Drawer>

        <Box
          className="px-0"
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            // ,paddingBottom: "81px"
          }}
        >
          <DrawerHeader />

          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MiniDrawer;
